import { render, staticRenderFns } from "./PatientConsultNote.vue?vue&type=template&id=e2df8d64&"
import script from "./PatientConsultNote.vue?vue&type=script&lang=js&"
export * from "./PatientConsultNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports